import auth from './auth'

export function getHome() {
  return auth.isAuthenticated() ? '/meinbereich/' : '/'
}
